<template>
  <v-flex xs12>
    <div class="step" @click="$router.push(params.link)">
      <div class="step-btn">
        <v-btn :class="getBtnCls(isSetup)" :outline="!isSetup" small fab>
          <v-icon v-if="isSetup">check</v-icon>
          <span v-if="!isSetup">{{params.position}}</span>
        </v-btn>
      </div>
      <div class="step-text">
        <div>
          <p class="step-header">
            <span v-if="isSetup" class="step-done">Готово</span>
            <span :class="{'step-through' : isSetup}">{{params.title}}</span>
          </p>
        </div>
        <div><p>{{params.description}}</p></div>
      </div>
    </div>
  </v-flex>
</template>

<script>
const LABELS = {
  reg: {
    link: '/',
    position: '1',
    title: 'Создайте аккаунт в Evriday',
    description: 'Первый и самый важный шаг сделан'
  },
  sms: {
    link: '/auth-setup',
    position: '2',
    title: 'Настройте смс-провайдера',
    description: 'Выберите вашего смс-провайдера и укажите логин и пароль для него.'
  },
  profile: {
    link: '/profile-setup',
    position: '3',
    title: 'Обновите настройки профиля',
    description: 'Настройте ваш профиль: укажите текст сообщения для смс и выберите цвета для записей в Yclients.'
  },
  page: {
    link: '/page-setup',
    position: '4',
    title: 'Настройте страницу подтверждения',
    description: 'Заполните информацию для страницы подтверждения, которую будут видеть ваши клиенты.'
  }
}

export default {
  data: () => ({
    init: false,
    initialSetup: {
      auth: true,
      profile: false,
      page: false,
      auto: false
    }
  }),
  props: {
    step: String,
    isSetup: Boolean
  },
  computed: {
    params () {
      return LABELS[this.step]
    }
  },
  methods: {
    getBtnCls: function (val) {
      if (val) {
        return 'btn-done'
      } else {
        return 'btn-active'
      }
    }
  }
}
</script>

<style scoped>
.btn-active {
  border-color: #3f51b5;
  color: #3f51b5;
}
.btn-done {
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
  color: #fff;
}
.step:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
.step {
  display: flex;
  position: relative;
  flex-wrap: nowrap;
}
.step-btn {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 8px;
}
.step-text {
  padding: 16px;
  padding-left: 78px;
}
.step-header {
  font-size: 18px;
}
.step-done {
  color:green;
  margin-right: 5px;
}
.step-through {
  text-decoration: line-through;
}
p {
  margin-bottom: 0;
}
</style>
